(function(){
  function getSrc(){try{return JSON.parse(decodeURIComponent((document.cookie.match('(^|;)\\s*dfw_lead_src\\s*=\\s*([^;]+)')||[]).pop()||'%7B%7D'));}catch(e){return {};}}
  function fire(reason){
    if (window.__dfwGa4GenerateLeadFired) return;
    if (typeof window.gtag !== 'function') return;
    window.__dfwGa4GenerateLeadFired = true;
    var s=getSrc();
    window.gtag('config','G-1FTJ4Y82RV',{'send_page_view':false});
    window.gtag('event','generate_lead',{send_to:'G-1FTJ4Y82RV',currency:'USD',value:100,lead_source:reason || (s.gclid?'Google Ads':'form'),lead_landing:s.land || location.pathname,campaign:s.utm_campaign || ''});
  }
  function maybeSuccess(){ if (/[?&]contact_posted=true/.test(location.search)) setTimeout(function(){fire('form_success_rescue');},1200); }
  document.addEventListener('submit',function(e){var f=e.target; if(!f || f.tagName!=='FORM') return; if ((f.getAttribute('action')||'').indexOf('/contact') !== -1 || f.id === 'dfw-contact-form' || f.id === 'contact_form') setTimeout(function(){fire('form_submit_rescue');},0);},true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',maybeSuccess); else maybeSuccess();
})();
